<app-status-summary [available]="available" [notAvailable]="notAvailable" [outOfOffice]="outOfOffice"></app-status-summary>

<!-- Mobile, Tablet, Desktop -->
<div class="mobile-cards">
  <div class="page">
    @for (statusGroup of agents$ | async; track statusGroup) {
      <app-card-frame [title]="statusGroup[0]?.CurrentEvent.Status.Item.GroupName" class="frame">
        @for (agent of statusGroup; track agent) {
          <app-agent-card [agent]="agent">
          </app-agent-card>
        }
      </app-card-frame>
    }
  </div>
</div>

<!-- TV -->
<div class="tv-cards">
  @if (agentPages$ | async; as agentPages) {
    <swiper-container
      #agentSwiper
      class="wallboard-slides"
      init="false"
      >
      @for (page of agentPages; track $index) {
        <swiper-slide>
          <div class="page">
            @for (statusGroup of page; track statusGroup) {
              <app-card-frame [title]="statusGroup[0]?.CurrentEvent.Status.Item.GroupName" class="frame">
                @for (agent of statusGroup; track agent) {
                  <app-agent-card [agent]="agent">
                  </app-agent-card>
                }
              </app-card-frame>
            }
          </div>
        </swiper-slide>
      }
    </swiper-container>
  }
</div>